import React, { useEffect } from "react";
import Layout from "../components/layout";
import "@components/layout.css";
import SEO from "../components/seo";
import Courses from "../components/courses";
import Header from "../components/header/";
import Experts from "../components/experts";
import Footer from "../components/footer";
import { graphql } from "gatsby";
import TwitterReviews from "../components/twitterReviews";
import { ExpectationsSection } from "../components/сardWithExpectation/сardWithExpectation";
import Subscription from "../components/subscription";

const IndexPage = ({ data }) => {
  const courses = data.allContentfulCourse.edges;
  const mainPage = data.allContentfulMainpage.edges[0].node;
  const footer = data.allContentfulFooter.edges[0].node;
  const experts = data.allContentfulExperts.edges.map(({ node }) => node);
  const reviews = data.allContentfulReviews.edges;

  useEffect(() => {
    var currentUtm = window.location.search.substr(1).split("&");
    if (currentUtm != "") {
      localStorage.setItem("currentUtm", currentUtm);
    }
  });

  return (
    <div>
      <Layout>
        <SEO title={"Курсы по web3-разработке: Solidity, NFT, DAO, DeFi"} />
        <Header mainPage={mainPage} />
        <Courses courses={courses} mainPage={mainPage} />
        <Subscription mainPage={mainPage} />
        <Experts experts={experts} />
        <div style={{ backgroundColor: "rgb(7, 8, 9)" }}>
          <ExpectationsSection />
          <TwitterReviews tweetsData={reviews} isAutoScroll={true} />
          <Footer footer={footer} mainPage={mainPage} />
        </div>
      </Layout>
    </div>
  );
};

export default IndexPage;

export const query = graphql`
  query CoursesQuery {
    allContentfulCourse(limit: 1000, sort: { fields: order }) {
      edges {
        node {
          id
          title
          deadline
          order
          mainCoursesInBundle
          mainDescProfession
          background {
            file {
              url
            }
          }
          logoForProfession {
            file {
              url
            }
          }
          tutor
          video
          nftUrl
          nftTokenId
          slug
          priceOld
          includes {
            text
          }
          skills {
            text
          }
          details
          audience {
            text
          }
          scheme {
            svg
            desc
            title
          }
          desc {
            desc
          }
          program {
            title
            text
          }
        }
      }
    }
    allContentfulMainpage {
      edges {
        node {
          title
          subtitle
          buttonText
          subscriptionText
          mainDescCourses {
            mainDescCourses
          }
          mainDescProfessions {
            mainDescProfessions
          }
          about {
            title
            desc
          }
        }
      }
    }
    allContentfulExperts {
      edges {
        node {
          company
          desc {
            desc
          }
          expertName
          intro
          twitter
          photo {
            file {
              url
            }
          }
        }
      }
    }
    allContentfulFooter {
      edges {
        node {
          instagramUrl
          telegramChannelUrl
          telegramUrl
          twitterUrl
          facebookUrl
          phone
          email
          wallet
          etherscanCompanyUrl
          etherscanWalletUrl
        }
      }
    }
    allContentfulReviews {
      edges {
        node {
          nick
          name
          link
          likes
          text {
            content {
              content {
                value
              }
            }
          }
          date
          avatar {
            file {
              url
            }
          }
        }
      }
    }
  }
`;
